var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.875H5C4.83424 9.875 4.67527 9.94085 4.55806 10.0581C4.44085 10.1753 4.375 10.3342 4.375 10.5C4.375 10.6658 4.44085 10.8247 4.55806 10.9419C4.67527 11.0592 4.83424 11.125 5 11.125H15C15.1658 11.125 15.3247 11.0592 15.4419 10.9419C15.5592 10.8247 15.625 10.6658 15.625 10.5C15.625 10.3342 15.5592 10.1753 15.4419 10.0581C15.3247 9.94085 15.1658 9.875 15 9.875Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 6.125H1.875C1.70924 6.125 1.55027 6.19085 1.43306 6.30806C1.31585 6.42527 1.25 6.58424 1.25 6.75C1.25 6.91576 1.31585 7.07473 1.43306 7.19194C1.55027 7.30915 1.70924 7.375 1.875 7.375H18.125C18.2908 7.375 18.4497 7.30915 18.5669 7.19194C18.6842 7.07473 18.75 6.91576 18.75 6.75C18.75 6.58424 18.6842 6.42527 18.5669 6.30806C18.4497 6.19085 18.2908 6.125 18.125 6.125Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 13.625H8.125C7.95924 13.625 7.80027 13.6908 7.68306 13.8081C7.56585 13.9253 7.5 14.0842 7.5 14.25C7.5 14.4158 7.56585 14.5747 7.68306 14.6919C7.80027 14.8092 7.95924 14.875 8.125 14.875H11.875C12.0408 14.875 12.1997 14.8092 12.3169 14.6919C12.4342 14.5747 12.5 14.4158 12.5 14.25C12.5 14.0842 12.4342 13.9253 12.3169 13.8081C12.1997 13.6908 12.0408 13.625 11.875 13.625Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionFunnel);
export default __webpack_public_path__ + "static/media/optionFunnel.da845a752a510496977898b55a16cff1.svg";
export { ForwardRef as ReactComponent };